import { connect } from "react-redux";
import ButtonMfa from "./buttonMfa";

export function mapStateToProps(state) {
  return {
    disabled:
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
    IsInternalView:
      state &&
      state.policyReducer &&
      state.policyReducer.policyDetails &&
      state.policyReducer.policyDetails.IsInternalView,
  };
}

export default connect(mapStateToProps)(ButtonMfa);
